/**
 * Author: ligj@mapbar.com
 * Create Time: 2018/03/23 15:40
 * Description:
 */
import Vue from 'vue';
/**
 * 图吧地图组件
 * 示例: <m-map :on-load="mapLoad" center="116.40049,39.9208" style="width: 100%;height: 200px;"/>
 *       mapLoad: function(maplet){}
 */

const loadMapApi = function(url, callback, errorCallback){
    var script = document.createElement("script");
    script.type = "text/javascript";
    var params = {
        window: window
    };
    function getCallbackParams() {
        return params;
    }
    if (script.readyState) { //IE
        script.onreadystatechange = function () {
            if (script.readyState == "loaded" || script.readyState == "complete") {
                script.onreadystatechange = null;
                callback(getCallbackParams());
            }
        };
    } else { //Others
        script.onload = function () {
            callback(getCallbackParams());
        };
    }
    script.onerror = function () {//顺序必须在append之前
        errorCallback(getCallbackParams());
    };
    script.src = url;

    document.body.appendChild(script);
}

let isFetching = false, mapletPromise = null;
const getMaplet = function(){
    if(!isFetching){
        isFetching = true;
        mapletPromise = new Promise((resolve, reject) => {
            if(window['Maplet']){
                isFetching = false;
                resolve(window['Maplet']);
            } else {
                loadMapApi(
                    'https://api.mapbar.com/api/mapbard31.4.js',
                    () => {
                        Vue.nextTick(() => {
                            isFetching = false;
                            resolve(window['Maplet']);
                        });
                    }),
                    (err) => {
                        isFetching = false;
                        reject(err);
                    }
            }
        });
    }
    return mapletPromise;
}

export default {
    data() {
        return {
            maplet: null
        }
    },
    props:{
        center: String,
        zoom: Number,
        onLoad: Function
    },
    methods: {
        mapResize(){
            if (this.maplet) { //自适应外部尺寸
                this.maplet.resize(this.$el.offsetWidth, this.$el.offsetHeight);
            }
        },
        documentClick(){
            this.$timeout(() => {
                if(this.$el.getBoundingClientRect().width > 0){
                    this.mapResize();
                }
            })
        }
    },
    async mounted(){

        //初始化地图
        await getMaplet();
        this.maplet = new Maplet(this.$el.querySelector('div'));
        this.maplet.centerAndZoom(new MPoint(this.$props.center || '116.40049,39.9208'), this.$props.zoom || 10);
        this.maplet.addControl(new MStandardControl()); //添加鱼骨
        this.maplet.showOverview(true,false); //添加鹰眼，默认不缩放
        this.maplet.setZoomLevelRange(4, 18); //控制地图缩放级别
        this.mapResize(); //设置地图尺寸
        window.addEventListener('resize', this.mapResize); //在屏幕尺寸发生变化的时候重新设置地图尺寸
        document.addEventListener('click', this.documentClick);

        this.onLoad && this.onLoad(this.maplet);//将new Maplet作为参数传递给外部调用者
    },
    destroyed(){
        if(this.maplet){
            window.removeEventListener('resize', this.mapResize);
            document.removeEventListener('click', this.documentClick);
            this.maplet.finalize(); //销毁地图实例
        }
    },
    activated(){
        if(this.maplet){
            this.mapResize();
            window.addEventListener('resize', this.mapResize);
            document.addEventListener('click', this.documentClick);
        }
    },
    deactivated(){
        if(this.maplet) {
            window.removeEventListener('resize', this.mapResize);
            document.removeEventListener('click', this.documentClick);
        }

    },
    render() {
        return <div><div></div></div>;
    }
};
